import { createSlice } from "@reduxjs/toolkit";
import _ from "lodash";
import moment from "moment";
const initialState = {
  manager: null,
  defaultFileStatus: null,
  defaultFolders: null,
  registryRights: [],
  availableStatuses: null,
  projectTasks: [],
  originalData: [],
  table: {
    search: "",
    limit: 11,
    page: 1,
    pages: 1,
    sort: "",
    data: [],
    searchFields: [
      { key: "index", name: "global:project.index" },
      { key: "projectName", name: "global:project.projectName" },
      {
        key: "projectManager.firstName, projectManager.lastName",
        name: "global:project.projectManager",
      },
      {
        key: "projectClient.firstName, projectClient.lastName",
        name: "global:project.projectClient",
      },

      { key: "status.name", name: "global:project.status" },
    ],
    selectedSearchFields: [
      "index",
      "projectName",
      "projectManager.firstName, projectManager.lastName",
      "projectClient.firstName, projectClient.lastName",
      "status.name",
    ],
    dictionaryFields: ["projectProjectType"],
    startDate: null,
    endDate: null,
    url: "project",
  },
};
const sortByKeys = (items, keys, isAscending) => {
  items.sort((a, b) => {
    for (const key of keys) {
      const valueA = _.get(a, key);
      const valueB = _.get(b, key);

      if (valueA === valueB) continue;
      if (valueA == null || valueB == null) return valueA == null ? 1 : -1;

      let result = 0;

      if (moment.isMoment(valueA) && moment.isMoment(valueB)) {
        result = valueA.isBefore(valueB) ? -1 : 1;
      } else if (key === "taskNumber" || key === "subtaskNumber") {
        result =
          parseInt(valueA.split("/")[1], 10) -
            parseInt(valueB.split("/")[1], 10) || valueA.localeCompare(valueB);
      } else if (typeof valueA === "string" && typeof valueB === "string") {
        result = valueA.localeCompare(valueB);
      } else {
        result = valueA > valueB ? 1 : -1;
      }

      return isAscending ? result : -result;
    }
    return 0;
  });
};
const projectReducer = createSlice({
  name: "projectReducer",
  initialState,
  reducers: {
    setRegistryRights: (state, { payload }) => {
      state.registryRights = payload;
    },
    updateManager: (state, { payload }) => {
      state.manager = payload;
    },
    updateDefaultFileStatus: (state, { payload }) => {
      state.defaultFileStatus = payload;
    },
    updateDefaultFolders: (state, { payload }) => {
      state.defaultFolders = payload;
    },
    updateAvailableStatuses: (state, { payload }) => {
      state.availableStatuses = payload;
    },
    updateRegistry: (state, { payload }) => {
      state.table = { ...state.table, ...payload };
    },
    updateProjectTasks: (state, { payload }) => {
      if (!Array.isArray(payload)) return;
      state.projectTasks = payload;
      state.originalData = [...payload];
    },
    sortProjectData: (state, { payload }) => {
      const { keys, isAscending } = payload;
      sortByKeys(state.projectTasks, keys, isAscending);
    },
    resetProjectData: (state) => {
      state.projectTasks = [...state.originalData];
    },
    sortSubtasks: (state, { payload }) => {
      const { taskUuid, keys, isAscending } = payload;
      const task = state.projectTasks.find((t) => t.uuid === taskUuid);
      if (task && task.subtasks) {
        sortByKeys(task.subtasks, keys, isAscending);
      }
    },

    clearRegistry: () => initialState,
  },
  extraReducers: {},
});

export const {
  updateRegistry,
  clearRegistry,
  updateManager,
  updateDefaultFileStatus,
  updateDefaultFolders,
  updateAvailableStatuses,
  setRegistryRights,
  updateProjectTasks,
  sortProjectData,
  sortSubtasks,
  resetProjectData,
} = projectReducer.actions;

export default projectReducer.reducer;
